import { Typography } from '@material-ui/core'

import { PaymentStatus } from '../../types/walletEnums'
import useStyles from './styles/StatusBox.styles'

interface BookingListAddFilterButtonProps {
  status: PaymentStatus
}

const StatusBox: React.FC<BookingListAddFilterButtonProps> = ({ status }) => {
  const classes = useStyles()
  const getColorForStatus = (s: PaymentStatus) => {
    switch (s) {
      case 'current':
        return 'lightYellow'
        break
      case 'overdue':
        return 'red'
        break
      case 'paid':
        return 'green'
      case 'upcoming':
        return 'lightBlue'
      case 'pendingPayment':
        return 'lightGrey'
      default:
        break
    }
  }
  return (
    <div className={classes.root}>
      {getColorForStatus(status) === 'red' ? (
        <Typography
          variant="body1"
          className={[classes.text, classes.red].join(' ')}>
          <span>{status}</span>
        </Typography>
      ) : null}

      {getColorForStatus(status) === 'green' ? (
        <Typography
          variant="body1"
          className={[classes.text, classes.green].join(' ')}>
          <span>{status}</span>
        </Typography>
      ) : null}

      {getColorForStatus(status) === 'lightBlue' ? (
        <Typography
          variant="body1"
          className={[classes.text, classes.lightBlue].join(' ')}>
          <span>{status}</span>
        </Typography>
      ) : null}
      {getColorForStatus(status) === 'lightYellow' ? (
        <Typography
          variant="body1"
          className={[classes.text, classes.lightYellow].join(' ')}>
          <span>{status}</span>
        </Typography>
      ) : null}
      {getColorForStatus(status) === 'lightGrey' ? (
        <Typography
          variant="body1"
          className={[classes.text, classes.lightGrey].join(' ')}>
          <span>{status}</span>
        </Typography>
      ) : null}
    </div>
  )
}

export default StatusBox
